"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var OpenInNew_1 = __importDefault(require("@material-ui/icons/OpenInNew"));
var FieldRenderer_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/field/FieldRenderer"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var colorsV2_1 = __importDefault(require("../../../assets/jss/colorsV2"));
var PasswordStrengthIndicator_1 = __importDefault(require("../../../shared/components/password/v2/PasswordStrengthIndicator"));
var framework_1 = require("../../../widgets/framework");
var styles_2 = __importDefault(require("../styles"));
var AccountCredentials = function (_a) {
    var updateField = _a.updateField, accountCredentialsFields = _a.accountCredentialsFields, passwordErrors = _a.passwordErrors, tosChecked = _a.tosChecked, handleTosChecked = _a.handleTosChecked, over18Checked = _a.over18Checked, handleOver18Checked = _a.handleOver18Checked;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var onOpenTerms = function (action) { return function () {
        var appNavigate = { action: action };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }; };
    var getAutoCompleteAttribute = function (fieldKey) {
        switch (fieldKey) {
            case 'firstName':
                return 'given-name';
            case 'lastName':
                return 'family-name';
            case 'dateOfBirth':
                return 'bday';
            case 'email':
                return 'email';
            case 'password':
                return 'new-password';
            default:
                return 'off';
        }
    };
    var renderFields = function () {
        return accountCredentialsFields.map(function (field) {
            var onFieldChange = function (newValue) {
                updateField(field.key, newValue);
            };
            var labelProps = {
                useAlternateTextField: true,
                isRequiredLabel: true,
                labelStyle: {
                    margin: theme.spacing(2, 0, 1, 2),
                    color: colorsV2_1.default.palette.neutralsN700.hex()
                }
            };
            return (react_1.default.createElement(Grid_1.default, { key: field.key, item: true, xs: 12, md: 12, lg: 10, className: classes.fieldContainer },
                react_1.default.createElement(FieldRenderer_1.default, { labelProps: labelProps, field: field, onChange: onFieldChange, inputProps: {
                        variant: 'outlined',
                        autoComplete: getAutoCompleteAttribute(field.key),
                        label: field.label,
                        required: true,
                        autoFocus: false,
                        helperText: field.key === 'dateOfBirth'
                            ? t('registrationPage.step1.dateHelperText')
                            : undefined
                    }, className: classes.field }),
                field.key === 'password' && (react_1.default.createElement(Box_1.default, { className: classes.passwordStrengthContainer },
                    react_1.default.createElement(PasswordStrengthIndicator_1.default, { password: field.value || '', passwordErrors: passwordErrors })))));
        });
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, item: true, xs: 12, alignItems: "flex-start", justifyContent: "center", style: { marginBottom: theme.spacing(2) } },
        renderFields(),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, md: 12, lg: 10, className: classes.fieldContainer },
            react_1.default.createElement(FormControlLabel_1.default, { style: { alignItems: 'flex-start' }, "aria-labelledby": "termsOfUseText", control: react_1.default.createElement(Checkbox_1.default, { id: "termsOfUseCheckbox", checked: tosChecked, onChange: handleTosChecked, color: "primary", style: { padding: theme.spacing(0.5), marginLeft: theme.spacing(1) }, required: true }), label: react_1.default.createElement(Typography_1.default, { id: "termsOfUseText", variant: "body1", style: { paddingTop: '4px' } },
                    t('registrationPage.step1.checkboxTermsOfUse1'),
                    "\u00A0",
                    react_1.default.createElement(Button_1.default, { color: "primary", variant: "text", role: 'link', onClick: onOpenTerms('TERMS_AND_CONDITIONS'), className: classes.link },
                        t('registrationPage.step1.checkboxTermsOfUse2'),
                        react_1.default.createElement(OpenInNew_1.default, { fontSize: 'small', className: classes.newTabIcon, "aria-hidden": false, "aria-label": 'opens in a new tab' })),
                    "\u00A0",
                    t('registrationPage.step1.checkboxTermsOfUse3'),
                    "\u00A0",
                    react_1.default.createElement(Button_1.default, { color: "primary", variant: "text", role: 'link', onClick: onOpenTerms('PRIVACY_POLICY'), className: classes.link },
                        t('registrationPage.step1.checkboxTermsOfUse4'),
                        react_1.default.createElement(OpenInNew_1.default, { fontSize: 'small', className: classes.newTabIcon, "aria-hidden": false, "aria-label": 'opens in a new tab' })),
                    "\u00A0",
                    t('registrationPage.step1.checkboxTermsOfUse5')) })),
        react_1.default.createElement(Grid_1.default, { item: true, xs: 12, md: 12, lg: 10, className: classes.fieldContainer },
            react_1.default.createElement(FormControlLabel_1.default, { style: { alignItems: 'flex-start' }, "aria-labelledby": "over18Text", control: react_1.default.createElement(Checkbox_1.default, { id: "over18Checkbox", checked: over18Checked, onChange: handleOver18Checked, color: "primary", style: { padding: theme.spacing(0.5), marginLeft: theme.spacing(1) }, required: true }), label: react_1.default.createElement(Typography_1.default, { id: "over18Text", variant: "body1", style: { paddingTop: '4px' }, "aria-hidden": "true" }, t('registrationPage.step1.over18Checkbox')) }))));
};
exports.default = AccountCredentials;
//# sourceMappingURL=AccountCredentials.js.map